(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vk2-text-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-vk2-marquee]';
  const trackSelector = '[data-vk2-marquee-track]';
  const sequenceSelector = '[data-vk2-marquee-sequence]';

  const initialiseSection = (section) => {
    if (!section || section.dataset.vk2MarqueeInitialised === 'true') return;

    const viewport = section.querySelector('.vk2-text-marquee__viewport');
    const track = section.querySelector(trackSelector);
    const sourceSequence = section.querySelector(sequenceSelector);
    const hasLinkedBlocks = section.dataset.hasLinkedBlocks === 'true';
    const desktopPointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (!viewport || !track || !sourceSequence) return;

    section.dataset.vk2MarqueeInitialised = 'true';

    let renderFrame;

    const removeClones = () => {
      track.querySelectorAll('.vk2-text-marquee__sequence--clone').forEach((clone) => clone.remove());
    };

    const createClone = () => {
      const clone = sourceSequence.cloneNode(true);
      clone.classList.add('vk2-text-marquee__sequence--clone');
      clone.removeAttribute('data-vk2-marquee-sequence');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((item) => {
        item.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('[data-vk2-marquee-link]').forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
      return clone;
    };

    const setLinkHovered = (isHovered) => {
      const canPauseOnHover = hasLinkedBlocks && desktopPointerQuery.matches;
      section.dataset.vk2LinkHovered = String(canPauseOnHover && isHovered);
    };

    const setLinkFocused = (isFocused) => {
      section.dataset.vk2LinkFocused = String(isFocused);
    };

    const render = () => {
      removeClones();

      const sequenceWidth = Math.ceil(sourceSequence.getBoundingClientRect().width);
      const viewportWidth = Math.ceil(viewport.getBoundingClientRect().width);

      if (!sequenceWidth || !viewportWidth) return;

      const cloneCount = Math.max(1, Math.ceil(viewportWidth / sequenceWidth) + 1);

      for (let index = 0; index < cloneCount; index += 1) {
        track.appendChild(createClone());
      }

      track.style.setProperty('--vk2-loop-distance', `-${sequenceWidth}px`);
    };

    const queueRender = () => {
      window.cancelAnimationFrame(renderFrame);
      renderFrame = window.requestAnimationFrame(render);
    };

    const handleLinkPointerOver = (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-vk2-marquee-link]');
      if (link && section.contains(link)) {
        setLinkHovered(true);
      }
    };

    const handleLinkPointerOut = (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-vk2-marquee-link]');
      const nextTarget = event.relatedTarget;

      if (link && (!nextTarget || !link.contains(nextTarget))) {
        setLinkHovered(false);
      }
    };

    const handleFocusIn = (event) => {
      if (event.target.matches('[data-vk2-marquee-link]')) {
        setLinkFocused(true);
      }
    };

    const handleFocusOut = (event) => {
      const nextTarget = event.relatedTarget;

      if (!nextTarget || !section.contains(nextTarget)) {
        setLinkFocused(false);
      }
    };

    const handlePointerCapabilityChange = () => setLinkHovered(false);

    queueRender();

    if (hasLinkedBlocks) {
      viewport.addEventListener('pointerover', handleLinkPointerOver);
      viewport.addEventListener('pointerout', handleLinkPointerOut);
      section.addEventListener('focusin', handleFocusIn);
      section.addEventListener('focusout', handleFocusOut);

      if (desktopPointerQuery.addEventListener) {
        desktopPointerQuery.addEventListener('change', handlePointerCapabilityChange);
      } else if (desktopPointerQuery.addListener) {
        desktopPointerQuery.addListener(handlePointerCapabilityChange);
      }
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(queueRender);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', queueRender, { passive: true });
    }
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      initialiseSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
